import DisclaimerPublic from './DisclaimerPublic';

export default DisclaimerPublic;
